import {Component, OnInit, ViewChild} from '@angular/core';
import {ApiResponse, BaseModalComponent, LanguagesQuery, LocalizationModel, LocalizationService} from "common-shared";
import {BehaviorSubject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {NgForm} from "@angular/forms";

@Component({
  selector: 'app-localization-edit',
  templateUrl: './localization-edit.component.html',
  styles: [
  ]
})
export class LocalizationEditComponent extends BaseModalComponent implements OnInit {
  key: string;
  isPristine$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  localizations: LocalizationModel[];
  @ViewChild(NgForm, {static: true}) form: NgForm;
  response: ApiResponse<any>;

  constructor(private localizationService: LocalizationService, public languagesQuery: LanguagesQuery) {
    super();
  }

  ngOnInit(): void {
    this.localizationService.getLocalizationInAllLanguages(this.key).pipe(takeUntil(this.componentDestroyed)).subscribe(localizations => {
      this.localizations = localizations;
    });

    this.form.statusChanges.subscribe(value => {
      this.isPristine$.next(this.form.pristine);
    });
  }

  save(withClose: boolean = true) {
    this.localizationService.save(this.localizations).subscribe(value => {
      this.localizations = value;
      if (withClose) {
        this.bsModalRef.close();
      }
    }, value1 => {
      this.response = value1.error;
    });
  }
}
